import type { RouteRecordRaw } from 'vue-router'

const featureFlagsRoutes: RouteRecordRaw[] = [
  {
    path: '/settings/feature-flags',
    name: 'feature-flags.index',
    component: () => import('@/modules/user/admin/views/FeatureFlagsIndex.vue'),
    meta: {
      pageTitle: 'Feature Flags',
      breadcrumbs: ['Settings', 'Feature Flags']
    }
  }
]

export default featureFlagsRoutes
